import { Component, ChangeDetectionStrategy } from '@angular/core';
//
import { CommonToastService } from '@common2/services/toast.service';

@Component({
    selector: 'msc-showroom-exhibit-loader-page',
    templateUrl: './showroom-exhibit-loader-page.component.html',
    styleUrls: ['./showroom-exhibit-loader-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitLoaderPageComponent {
    constructor(
        private readonly toastService: CommonToastService,
    ) { }

    /**
     *
     */
    onEvent(): void {
        this.toastService.onSuccess(`💥 Boom! 💥`);
        this.toastService.onSuccess(`💥 Boom! 💥`);
        this.toastService.onSuccess(`💥 Boom! 💥`);
    }
}
